import { API_URL, NEW_API_URL } from "@config";
import { components as apiComponentTypes } from "./schema";
import createApi from "./createApi";

export type {
  IResponse,
  IErrorResponse,
  IApiResponse,
  IResponseStatus,
  IProgressEvent,
} from "./createApi";

export type IApiErrors = apiComponentTypes["schemas"]["errors"];
export type IApiMonoError = apiComponentTypes["schemas"]["error"];
export type IApiErrorsItem = { text: string } & { [key: string]: string };
export type IApiError = IApiErrors | IApiMonoError;

export type IApiResource<
  T extends object,
  IO extends object | undefined = undefined,
  F extends (keyof T)[] | undefined = undefined
> = (F extends undefined ? T : Pick<T, F[number]>) & {
  [key in keyof IO]: IO[key];
};

export interface IError {
  text: string;
  message: string;
}

export const createApiWithNoBasePath = createApi();

export const createApiWithNewBasePath = createApi({ baseURL: NEW_API_URL });

export default createApi({ baseURL: API_URL });
